import template from './prems-discount-category-detail.html.twig';
import "./prems-discount-category-detail.scss";

const { Criteria } = Shopware.Data;
const { Mixin } = Shopware;
const { mapPropertyErrors } = Shopware.Component.getComponentHelper();

Shopware.Component.register('prems-discount-category-detail', {
    template: template,

    inject: [
        'repositoryFactory',
    ],

    mixins: [
        Mixin.getByName('placeholder'),
        Mixin.getByName('notification')
    ],

    shortcuts: {
        'SYSTEMKEY+S': 'onSave',
        ESCAPE: 'onCancel'
    },

    props: {
        discountCategoryId: {
            type: String,
            required: false,
            default: null
        },
    },

    data() {
        return {
            isLoading: false,
            isSaveSuccessful: false,
            defaultTypeOption: 'custom',
            discountCategory: null
        }
    },

    computed: {
        discountCategoryBaseRepository() {
            return this.repositoryFactory.create('prems_discount_category_base');
        },
        discountCategoryBaseCriteria() {
            const criteria = new Criteria(1, 100);

            return criteria;
        },

        ...mapPropertyErrors('discountCategory', ['name', 'discount']),
    },

    watch: {
        discountCategoryId() {
            this.createdComponent();
        }
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            if (this.discountCategoryId) {
                this.loadEntityData();
                return;
            }

            this.discountCategory = this.discountCategoryBaseRepository.create();
            this.discountCategory.categoryIdsMode = 0;
            this.discountCategory.displayTypeDiscountOnDetailPage = 0;
            this.discountCategory.displayTypeDiscountOnListingPage = 0;
            this.discountCategory.isUpprice = false;
            this.discountCategory.type = '0';
            this.discountCategory.priority = 0;
        },

        loadEntityData() {
            this.isLoading = true;
            return this.discountCategoryBaseRepository.get(this.discountCategoryId, { ...Shopware.Context.api, inheritance: true }, this.discountCategoryBaseCriteria)
                .then((discountCategory) => {
                    discountCategory.categoryIdsMode = discountCategory.categoryIdsMode.toString();
                    this.discountCategory = discountCategory;
                }).finally(() => {
                    this.isLoading = false;
                });
        },

        saveOnLanguageChange() {
            return this.onSave();
        },
        abortOnLanguageChange() {
            return this.discountCategoryBaseRepository.hasChanges(this.discountCategory);
        },

        onChangeLanguage() {
            this.loadEntityData();
        },

        onCancel() {
            this.$router.push({ name: 'prems.discount.category.list' });
        },

        onSave() {
            this.isLoading = true;
            this.discountCategory.categoryIdsMode = parseInt(this.discountCategory.categoryIdsMode, 10);
            this.discountCategoryBaseRepository.save(this.discountCategory, Shopware.Context.api).then(() => {
                this.isLoading = false;
                this.isSaveSuccessful = true;
                if (this.discountCategoryId === null) {
                    this.$router.push({ name: 'prems.discount.category.detail', params: { id: this.discountCategory.id } });
                    return;
                }

                this.loadEntityData();
            })
            .catch(error => {
                console.log(error);
                this.isLoading = false
            });
        },

        saveFinish() {
            this.isSaveSuccessful = false;

            if (!this.discountCategoryId) {
                this.$router.push({ name: 'prems.discount.category.detail', params: { id: this.discountCategory.id } });
            }
        },

        getRouteForView(view) {
            const create = { name: 'prems.discount.category.create.' + view };
            const detail = { name: 'prems.discount.category.detail.' + view, params: { id: this.discountCategoryId } };
            return this.discountCategoryId ? detail : create;
        }
    }
});
